<div
  class="input-value-container"
  ngClass="{{ invalidInput() ? 'input-value-container--invalid' : '' }}"
  >
  <input
    class="input-value"
    (input)="inputUpdated()"
    [(ngModel)]="currentInputValue"
    type="text"
  >
  <div class="input-units">
    {{ currency }}
  </div>
</div>

@if(invalidInput() && invalidText) {
  <div class="invalid-input-text">
    @if(aboveMax) {
      {{ invalidText.max }}
    }
    @if(underMin) {
      {{ invalidText.min }}
    }
  </div>
}